import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import { requiredFiles } from '../../../useValidateQuestionnaire';
import {
  PensionStateValues,
  TCountryPensionTypeRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  keyof PensionStateValues | keyof TCountryPensionTypeRow
>[] = [
  {
    dependenciesTitle: 'Pension Contributions',
    name: 'didYouMakeContributionsToAUsIraRothIraOrSepAccountsDuringTheFilingYear',
    label:
      'Did you make contributions to a US IRA, ROTH IRA, or SEP accounts during the filing year?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'form5498ReportingIraorRothIraContributionForTaxYear',
        label:
          'Form 5498 reporting IRA (or ROTH IRA) contribution for tax year',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      // {
      //   name: 'doYouHaveForm5498',
      //   label: 'Do you have Form 5498?',
      //   type: 'radio',
      //   predicate: (value) => value === 'yes',
      //   tooltip: '',
      //   comment: true,
      //   effect: updateKeyInStore(updateKey),
      //   dependencies: [
      //     {
      //       name: 'retirementPlanDetails',
      //       label: 'Retirement plan details',
      //       type: 'select',
      //       options: [
      //         { label: 'Traditional IRA', value: 'Traditional IRA' },
      //         { label: 'ROTH IRA', value: 'ROTH IRA' },
      //         { label: 'SEP-IRA', value: 'SEP-IRA' },
      //       ],
      //       predicate: (value) => value === 'no',
      //       tooltip: '',
      //       comment: true,
      //       effect: updateKeyInStore(updateKey),
      //     },
      //     {
      //       name: 'amountContributedToTheRetirementPlan',
      //       label: 'Amount contributed to the retirement plan',
      //       type: 'currency',
      //       predicate: (value) => value === 'no',
      //       tooltip: '',
      //       comment: true,
      //       effect: updateKeyInStore(updateKey),
      //     },
      //   ],
      // },
    ],
  },
  {
    dependenciesTitle: 'Pension Distributions',
    name: 'didYouReceiveUsRetirementDistributions',
    label: 'Did you receive US retirement distributions?',
    subLabel: () => (
      <p>IE Social Security, IRA, 401-K, government or military pension</p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadForm1099ROrSsa1099',
        label: 'Please upload form 1099-R or SSA-1099',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'nonUsTaxesPaidOnUsRetirementDitributions',
        label: 'Non-US taxes paid on US retirement ditributions',
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },

  {
    name: 'didYouReceieveForeignieNonUsRetirementDistributions',
    label: 'Did you receieve Foreign (ie non-US) retirement distributions?',
    subLabel: () => (
      <p>Such as government/ private pension or disability payments</p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'countryPensionTypeList',
        label: 'Country & Pension Type List',
        type: 'fieldArray',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          grossAmountReceived: null,
          country: null,
          pensionType: null,
        },
        dependencies: [
          {
            name: 'grossAmountReceived',
            label: 'Gross Amount received',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },

          {
            name: 'country',
            label: 'Country',
            type: 'country',
            placeholder: 'Select Country',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'pensionType',
            label: 'Pension Type',
            type: 'select',
            options: [
              {
                label: 'Social Secuiry',
                value: 'Social Secuiry',
              },
              {
                label: 'Employer Pension',
                value: 'Employer Pension',
              },
              {
                label: 'Individual Pension',
                value: 'Individual Pension',
              },
            ],
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'foreignTaxPaid',
            label: 'Foreign Tax Paid',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
  {
    name: 'didYouRolloverOrOtherwiseTransferAmountsBetweenRetirementAccountsDuringTheYear',
    label:
      'Did you rollover, or otherwise transfer amounts between retirement accounts during the year (US or non-US)',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'didYouPerformARolloverBetweenTraditionalIraAndRothIra',
        label:
          'Did you perform a rollover between Traditional IRA and Roth IRA?',
        subLabel: () => <p>Refers to either complete or partial rollover</p>,
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            name: 'pleaseUploadSupportingDocumentation',
            label: 'Please upload supporting documentation',
            type: 'upload',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
          },
        ],
      },
      {
        name: 'didYouPerformARolloverBetweenNonUSRetirementAccounts',
        label: 'Did you perform a rollover between non-US retirement accounts?',
        subLabel: () => <p>To U.S. or other non-US accounts</p>,
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            name: 'pleaseUploadSupportingDocumentationFullDetails',
            label: 'Please upload supporting documentation & full details',
            type: 'upload',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
          },
        ],
      },
    ],
  },

  {
    name: 'areAnyOfThePensionsTheResultOfWorkPerformedForTheFederalGovernmentOrAnyPoliticalSubdivision',
    label:
      'Are any of the pensions the result of work performed for the federal government or any political subdivision?',
    subLabel: () => (
      <>
        <p>
          If any distributions, please make sure to complete the table above.
          This is important for us to understand if you are eligible for any
          treaty exemptions.
        </p>
        <p>Local, municipal, city, etc.</p>
      </>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
